module.exports = __webpack_public_path__ + "media/images/favicon_pinned-bc89efb3bc619691c477ca7e12ce2805.ico";